import React from 'react';
import { Briefcase, Users, TrendingUp, Heart } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const Careers = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: 'Career Growth',
      description: 'Continuous learning opportunities and clear career progression paths'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Work alongside industry veterans and talented professionals'
    },
    {
      icon: Briefcase,
      title: 'Major Projects',
      description: 'Get involved in some of the most exciting oil & gas projects globally'
    },
    {
      icon: Heart,
      title: 'Work Culture',
      description: 'Dynamic, innovative environment built on core values and mutual respect'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Join Our <span className="text-red-600">Team</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Be part of something extraordinary. Build your career with industry leaders.
          </p>
        </div>

        {/* Hero Section */}
        <div className="mb-16 relative rounded-2xl overflow-hidden">
          <div
            className="h-96 bg-cover bg-center"
            style={{
              backgroundImage:
                'url(https://images.pexels.com/photos/5257005/pexels-photo-5257005.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70 flex items-center">
              <div className="max-w-3xl px-8 md:px-16">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">Want to Join Us?</h3>
                <p className="text-lg text-slate-200 leading-relaxed">
                  The opportunity that comes with growth and new experiences. The opportunity to contribute new ideas
                  to established operations. The chance to build your capability through our strong network. We offer
                  all of this and more.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300 bg-white">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-lg font-bold text-slate-900 mb-2">{benefit.title}</h4>
                <p className="text-slate-600 text-sm">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Description */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-6">Why Choose Total Vision?</h3>
          <div className="space-y-4 text-slate-600 leading-relaxed">
            <p>
              Ours is an exciting and dynamic business. New thinking is founded on established values that sit at the
              heart of everything we do. You can see them in action everywhere you look, from the innovative,
              high-quality and responsive services we offer to the way we keep our people safe.
            </p>
            <p>
              When you join us on our journey, you will have the opportunity to get involved in some truly exciting
              projects, where we design and build oil and gas infrastructure, operate, maintain and manage assets,
              and train personnel.
            </p>
            <p>
              We're committed to fostering a culture of continuous improvement, innovation, and excellence. Our team
              members are our greatest asset, and we invest in their development through training, mentoring, and
              career advancement opportunities.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-r from-red-600 to-indigo-800 rounded-2xl p-8 md:p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">Ready to Start Your Journey?</h3>
            <p className="text-lg mb-6 text-red-100">
              Explore our current openings and take the next step in your career
            </p>
            <Button size="lg" className="bg-white text-red-600 hover:bg-slate-100">
              View Open Positions
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;